import React, { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import PublicShell from "@/components/PublicShell";
import { DisclosureDocs, DOW_DISCLOSURES_PDF as PDF } from "@/components/wizard/dow/DisclosureDocs";
const RETURN_URL = "https://www.cognitoforms.com/BaseEntInc/TheDioceseOfWilmington";

export default function DowDisclosures() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    const prev = document.title;
    document.title = "Diocese of Wilmington Disclosures | Info Retrieval Services";
    return () => { m.remove(); document.title = prev; };
  }, []);
  return (
    <PublicShell>
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#E8573A]">The Diocese of Wilmington</p>
        <h1 className="mt-1 text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid="dow-disclosures-title">Background check disclosures</h1>
        <p className="mt-3 max-w-2xl text-base text-[#64748B]">Please review the disclosures below. When you're done, click the button at the bottom to return to your application form.</p>
        <div className="mt-8"><DisclosureDocs /></div>
        <p className="mt-3 text-sm text-[#64748B]">Can't see the document? <a href={PDF} target="_blank" rel="noreferrer" className="font-semibold text-[#1B365D] underline" data-testid="dow-disclosures-open-link">Open it in a new tab</a>.</p>
        <div className="mt-8 flex justify-center">
          <a href={RETURN_URL} className="btn-primary" data-testid="dow-disclosures-return-button">I've reviewed the disclosures, return to my form <ArrowRight className="h-4 w-4" /></a>
        </div>
      </div>
    </PublicShell>
  );
}
